import React from "react";
import "../../pages/Machine.css";

const DeleteConfirmationModal = ({ machine, onCancel, onConfirm }) => {
  return (
    <div className="modal-overlay">
      <div className="modal small-modal">
        <div className="modal-header">
          <h3>Confirm Delete</h3>
        </div>
        <div className="modal-body">
          <p>
            Are you sure you want to delete{" "}
            <strong>{machine?.machine_name}</strong>?
          </p>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onCancel}>
            No
          </button>
          <button className="btn btn-danger" onClick={onConfirm}>
            Yes, Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;